<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.75 8.74997L21.25 21.25" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M21.25 8.74997L8.75 21.25" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

</template>
